import Th from "./Th";

export default Th;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Th/index.js